const cardItems = [
  {
    title: '2024年度最受欢迎日漫排行榜',
    desc: '根据酷漫屋全年阅读数据统计，盘点读者最爱的日漫作品TOP20，看看你追的上榜了吗？',
    img: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20collection%20display%20with%20colorful%20covers%20spread%20out%2C%20warm%20lighting%2C%20clean%20flat%20lay%20style%2C%20vibrant%20colors%2C%20minimal%20cream%20background%2C%20editorial%20photography%20style&width=800&height=500&seq=card-manga-01&orientation=landscape',
    tag: '年度盘点',
    icon: 'ri-medal-line',
  },
  {
    title: '韩漫条漫阅读新体验：竖屏沉浸式',
    desc: '韩漫特有的竖屏条漫格式配合下拉式滚动，带给你前所未有的流畅追漫享受。',
    img: 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20colorful%20vertical%20webtoon%20scrolling%20scene%2C%20modern%20Korean%20digital%20art%20style%2C%20bright%20and%20vibrant%20colors%2C%20clean%20composition%2C%20minimal%20beige%20background&width=800&height=500&seq=card-manga-02&orientation=landscape',
    tag: '阅读指南',
    icon: 'ri-smartphone-line',
  },
  {
    title: '国漫新番速递：本周必追连载推荐',
    desc: '精选本周最新上线的国产漫画连载，涵盖古风武侠、都市奇幻等多种热门题材。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20ink%20painting%20style%20fantasy%20illustration%20with%20flowing%20robes%20and%20ancient%20architecture%2C%20elegant%20golden%20and%20crimson%20tones%2C%20traditional%20aesthetic%20with%20modern%20touch%2C%20minimal%20warm%20background&width=800&height=500&seq=card-manga-03&orientation=landscape',
    tag: '新番速递',
    icon: 'ri-rocket-2-line',
  },
  {
    title: '漫画分类导航：快速找到你的本命作品',
    desc: '按题材、地区、热度等多维度筛选，酷漫屋帮你从海量漫画中精准定位心仪作品。',
    img: 'https://readdy.ai/api/search-image?query=Colorful%20organized%20manga%20catalog%20grid%20display%20with%20various%20genre%20icons%2C%20clean%20modern%20design%2C%20warm%20and%20inviting%20color%20scheme%2C%20flat%20illustration%20style%2C%20minimal%20white%20background&width=800&height=500&seq=card-manga-04&orientation=landscape',
    tag: '使用技巧',
    icon: 'ri-compass-3-line',
  },
  {
    title: '冷门佳作挖掘：那些被低估的宝藏漫画',
    desc: '酷漫屋编辑团队精心筛选的小众精品，每一部都是值得细细品味的漫画佳作。',
    img: 'https://readdy.ai/api/search-image?query=Hidden%20gem%20manga%20collection%20with%20unique%20art%20styles%20showcased%2C%20warm%20golden%20lighting%2C%20artistic%20flat%20lay%20composition%2C%20vintage%20and%20modern%20mix%2C%20minimal%20cream%20background&width=800&height=500&seq=card-manga-05&orientation=landscape',
    tag: '编辑精选',
    icon: 'ri-sparkling-2-line',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-3">
          精选推荐
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          精心挑选的漫画推荐与实用追漫指南
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cardItems.map((item, i) => (
            <div
              key={item.title}
              className={`group bg-background-50 rounded-2xl border border-background-200/80 overflow-hidden cursor-pointer transition-transform hover:-translate-y-1 ${
                i === 3 ? 'sm:col-span-2 lg:col-span-3' : ''
              }`}
            >
              <div className={`flex ${i === 3 ? 'flex-col sm:flex-row' : 'flex-col'}`}>
                <div className={`relative overflow-hidden bg-background-200 ${
                  i === 3 ? 'w-full sm:w-1/3 aspect-video sm:aspect-auto sm:min-h-[180px]' : 'w-full aspect-[8/5]'
                }`}>
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <span className="absolute top-3 left-3 px-2 py-0.5 rounded-md bg-white/90 text-xs font-medium text-primary-600 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className={`p-4 md:p-5 ${i === 3 ? 'sm:w-2/3' : ''}`}>
                  <div className="flex items-center gap-2 mb-2">
                    <div className="w-6 h-6 rounded-full bg-primary-100 flex items-center justify-center">
                      <i className={`${item.icon} text-primary-500 text-xs`}></i>
                    </div>
                    <h3 className="text-sm md:text-base font-medium text-foreground-800">{item.title}</h3>
                  </div>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}